
export const content = {
    title: "SALES PRESENTATIONS IN REAL LIFE",
    subtitle: "How sellers spend their time",
    items: [
        {
            title: "Preparation",
            iconName: "fa-2x fas fa-book",
            text: "If they have time, they look at the company about section, some might even look at LinkedIn... :)"
        },
        {
            title: "Meeting",
            iconName: "fa-2x fas fa-plane",
            text: "This is where they use most time, they go with the mix of slides that use to work mixed with anecdotes"
        },
        {
            title: "Follow-up",
            iconName: "fa-2x far fa-comment-dots",
            text: "If we don’t hear back, we call you when our sales leader need the pipeline updated"
        }
    ]
};

export default content;


// WEBPACK FOOTER //
// ./src/content/components/time-allocation.js